import _ from 'lodash';

import PropTypes from 'prop-types';

import { FadeInAnimation } from '../../shared';

const RoomTypeLocation = (props) => {
    const { selectedRoomType, roomContentCMS } = props;
    const iconSrc = _.get(roomContentCMS, 'acf.map_pin_icon.url');
    const longitude = _.get(selectedRoomType, 'buildingAddress.longitude');
    const latitude = _.get(selectedRoomType, 'buildingAddress.latitude');

    return (
        <FadeInAnimation>
            <div id="location-section">
                <h3 style={{ marginTop: 100, marginBottom: 15 }}>Location</h3>
                <p className='room-type-location-details'>
                    Centrally located in the heart of the CBD, close to all major taxi routes, HOMii
                    is where it&apos;s all happening!
                </p>

                <a className='room-type-location-anchor-tag'
                    href={`//www.google.com/maps/search/?api=1&query=${latitude},${longitude}`}
                    rel="noreferrer"
                    target="_blank"
                >
                    <img className='room-type-location-img'
                        src={`https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=15&size=900x400
                                &markers=icon:${iconSrc}|${latitude},${longitude}&key=AIzaSyB4ee6dZHAKJYXn06J8pP-nu0DlHfuvtsY`}
                        alt="google-map"
                        width="100%"
                    />
                </a>
            </div>
        </FadeInAnimation>
    );
};

export default RoomTypeLocation;

RoomTypeLocation.propTypes = {
    selectedRoomType: PropTypes.object,
    roomContentCMS: PropTypes.object,
};

